import React from 'react';
import './WetlandsInfo.css';

const WetlandsInfo = () => {
  return (
    <div className="wetlands-info-page">
      <div className="wetlands-info-container">

        {/* 1. UVOD */}
        <h2>1. Uvod</h2>
        <p>
          Vlažna staništa su među najvrednijim ekosistemima na planeti. Ona obezbeđuju prečišćavanje vode, zaštitu od poplava, skladištenje ugljenika. Močvare funkcionišu kao prirodni filteri - tiho i neprimetno čiste vodu koju svakodnevno koristimo, bez ikakve naplate i bez prestanka. Ova staništa deluju i kao ogromni sunđeri: kada padnu obilne kiše, močvare upijaju višak vode i tako štite naselja, puteve i poljoprivredna zemljišta od poplava. Usled klimatskih promena, ova njihova uloga postaje važnija nego ikada.
        </p>
        <p>
          Vlažna staništa su i dom neverovatnom broju životinjskih i biljnih vrsta. U njima žive retke ptice, vodozemci, ribe, insekti, ali i biljke koje ne mogu da opstanu nigde drugde. Često se kaže da su vlažna staništa „kolevka biodiveziteta" - mesta gde se rađa i obnavlja život. Iako ponekad izgledaju skromno, zaraslo ili neuređeno, vlažna staništa su zapravo skriveni heroji prirode. Osim što su dom životinja i biljaka, ona utiču na zdravlje ljudi jer poboljšavaju kvalitet vazduha, vode i zemljišta. Mnoga od njih su i važna mesta za rekreaciju, posmatranje ptica, edukaciju dece i odmor u prirodi.
        </p>
        <p>
          Nažalost, vlažna staništa su među najugroženijim ekosistemima na svetu. Mnoge močvare su isušene, zatrpane ili zagađene, a vrste koje u njima žive nestaju pre nego što ih uopšte upoznamo. Zato je važno da ih prepoznamo, razumemo i čuvamo.
        </p>
        <p>
          Svaki pojedinac može da doprinese - jednom fotografijom, jednim opažanjem, jednim unosom u aplikaciju. Upravo zato postoji ČuvarMočvara: da zajedno pratimo stanje naših vlažnih staništa i pomognemo njihovoj zaštiti.
        </p>

        {/* 2. GRAĐANSKA NAUKA */}
        <h2>2. Građanska nauka</h2>
        <p>
          Građanska nauka podrazumeva učešće običnih ljudi, laika, u prikupljanju podataka o prirodi. To znači da svako od nas - šetač, ribolovac, biciklista, učenik ili slučajni prolaznik, može svojim opažanjima da doprinese nauci. Kada građani beleže stanje vode, vrste koje vide ili opasnosti koje primete, oni stvaraju dragocenu bazu podataka koju stručnjaci sami ne bi mogli da prikupe, jer ne mogu da budu na svakom mestu u svakom trenutku. Zato je građanska nauka ključna za očuvanje vlažnih staništa. Ona omogućava da se problemi uoče na vreme, da se promene prate kroz duži period i da se odluke o zaštiti zasnivaju na stvarnim, terenskim informacijama.
        </p>
        <p>
          U mnogim evropskim zemljama građanska nauka je već postala stub zaštite prirode. U Velikoj Britaniji, volonteri građani redovno prate insekte u rekama, pa su upravo oni prvi otkrili više slučajeva zagađenja koji bi inače ostali neprimećeni. U Holandiji, građani učestvuju u merenju nivoa vode i kvaliteta kanala, što je pomoglo u planiranju odbrane od poplava i obnovi degradiranih močvara. U Španiji, građanska posmatranja ptica močvarica doprinela su zaštiti najvažnijih močvarnih područja u Evropi.
        </p>
        <p>
          Ovi primeri pokazuju koliku moć imaju hiljade očiju i mobilnih telefona kada se uključe u zaštitu prirode. Srbija ima bogata, ali ugrožena vlažna staništa. Nedostaje nam redovno praćenje, brza reakcija na zagađenja i dugoročni podaci o promenama u prirodi. Upravo zato je građanska nauka dragocena, ona omogućava da svako od nas postane čuvar prirode, a da stručnjaci dobiju informacije koje sami ne bi mogli da prikupe. ČuvarMočvara je prvi korak ka tome da Srbija dobije mrežu građana koji aktivno štite svoje vode.
        </p>

        {/* 3. VLAŽNA STANIŠTA */}
        <h2>3. Vlažna staništa</h2>
        <p>
          Vlažna staništa su područja gde se voda zadržava stalno ili povremeno, stvarajući uslove za biljke i životinje koje mogu da opstanu samo u vlažnom okruženju.
        </p>
        <p>
          Ona obuhvataju širok raspon staništa - od bara i močvara do jezera, izvora, reka i kanala - i predstavljaju jedne od najvažnijih ekosistema za očuvanje biodiverziteta i prirodnih vodnih procesa.
        </p>

        {/* 3.1 */}
        <h3>3.1. Tipovi vlažnih staništa (najvažnija)</h3>
        <ol>
          <li><strong>BARA</strong> - Mala, plitka stajaća voda koja često presuši tokom leta.</li>
          <li><strong>MOČVARA</strong> - Stalno vlažno područje obraslo gustom vegetacijom poput trske i rogoza.</li>
          <li><strong>JEZERO</strong> - Velika i dublja vodena površina sa stabilnim nivoom vode.</li>
          <li><strong>IZVOR</strong> - Mesto gde hladna i bistra podzemna voda izbija na površinu. Može biti betoniran.</li>
          <li><strong>POTOK</strong> - Mali vodotok sa brzom i bistrom tekućom vodom.</li>
          <li><strong>REKA</strong> - Veliki vodotok sa stalnim protokom i različitim tipovima obala.</li>
          <li><strong>KANAL</strong> - Veštački vodotok ravan i prav, napravljen radi upravljanja vodama.</li>
          <li><strong>VLAŽNA LIVADA</strong> - Travnata površina stalno vlažna ili povremeno poplavljena.</li>
          <li><strong>TRESAVA</strong> - Posebna vrsta vlažnog staništa sa puno mahovina (tresetnica), često spužvasta podloga.</li>
          <li><strong>MRTVAJA</strong> - Deo starog rečnog korita koji se odvojio od glavnog toka i postao stajaća voda.</li>
        </ol>

        {/* 3.2 */}
        <h3>3.2. Bistrina vode - zašto je važno</h3>
        <p>
          Bistrina vode je jedan od najjednostavnijih, ali i najkorisnijih pokazatelja zdravlja vodenog ekosistema. Čak i kratko vizuelno opažanje može da otkrije mnogo o tome šta se dešava u vodi, da li je stanište stabilno, da li postoji zagađenje, ili da li je došlo do poremećaja u prirodnim procesima. Zato je važno da građani zabeleže kako voda izgleda u trenutku posmatranja.
        </p>
        <h4>Bistra voda</h4>
        <p>
          Voda je potpuno jasna, vidi se dno i predmeti ispod površine. Ovo obično znači da je ekosistem u dobrom stanju, da nema prekomerne sedimentacije i da je protok vode stabilan. Bistra voda često ukazuje na zdravu zajednicu biljaka i životinja. Ako se inače bistra voda iznenada zamuti, to može biti prvi znak problema.
        </p>
        <h4>Blago mutna voda</h4>
        <p>
          Voda ima blago mlečnu nijansu, ali se oblici u vodi još vide. Ovo može biti sasvim prirodno, posle kiše, vetra ili aktivnosti životinja. Blaga mutnoća može ukazivati na početak erozije ili povećan unos čestica u vodu. Ako se često ponavlja, može značiti da se nešto menja u okruženju.
        </p>
        <h4>Mutna voda</h4>
        <p>
          Voda je vrlo mutna; dno se ne vidi. Ovo je najčešće znak da se u vodu unosi velika količina sedimenta, otpada ili zagađivača. Mutna voda može biti posledica: radova uz vodotok, erozije zemljišta, ispuštanja otpadnih voda, poplava, intenzivne poljoprivrede. Mutnoća smanjuje količinu svetlosti u vodi, što utiče na biljke, ribe i vodozemce. Zato je važno da građani prijave ovakvo stanje, to može biti prvi signal da je ekosistem ugrožen.
        </p>
        <p><strong>Zašto je važno da građani ovo beleže?</strong></p>
        <ul>
          <li>Stručnjaci ne mogu biti svuda, ali građani mogu da zabeleže promene čim se dese.</li>
          <li>Bistrina vode se može promeniti u roku od nekoliko sati, zato su terenska opažanja dragocena.</li>
          <li>Veliki broj prijava pomaže da se uoče obrasci: gde se voda najčešće muti, kada i zbog čega.</li>
          <li>Ovi podaci pomažu u otkrivanju zagađenja, erozije i drugih problema pre nego što postanu ozbiljni.</li>
          <li>Građanska nauka omogućava da se stanje voda prati dugoročno, što je ključno za zaštitu vlažnih staništa.</li>
        </ul>

        {/* 3.3 */}
        <h3>3.3. Boja vode - zašto je važno</h3>
        <p>
          Boja vode je jedan od najbržih načina da procenimo šta se dešava u vodenom staništu. Iako deluje jednostavno, promena boje često je prvi znak da se u ekosistemu nešto menja, bilo prirodno, bilo zbog ljudskog uticaja. Zato je važno da građani zabeleže boju vode u trenutku posmatranja, jer takvi podaci pomažu da se otkriju problemi koji bi inače ostali neprimećeni.
        </p>
        <h4>Providna</h4>
        <p>
          Normalna boja za čiste vode. Voda izgleda prirodno, bez vidljivih promena. Ekosistem je stabilan, nema prekomernog unosa sedimenta, nema cvetanja algi.
        </p>
        <h4>Zelena</h4>
        <p>
          Najčešće ukazuje na prisustvo algi. Malo algi je normalno, ali intenzivno zelenilo može biti znak eutrofikacije - kada voda dobije previše hranljivih materija (najčešće iz poljoprivrede ili kanalizacije). Ako se zelena boja ponavlja ili širi, to može dovesti do smanjenja kiseonika i uginuća riba.
        </p>
        <h4>Braon</h4>
        <p>
          Boja sedimenta, mulja ili erozije. Mogući uzroci: jake kiše, radovi uz vodotok, urušavanje obala, poljoprivredni oticaj. Braon voda može ukazivati na degradaciju staništa i povećanu sedimentaciju, što utiče na biljke i životinje.
        </p>
        <h4>Siva</h4>
        <p>
          Moguće zagađenje. Najčešći uzroci: industrijski otpad, betonska prašina, ispuštanje otpadnih voda. Ovo je boja koja zahteva posebnu pažnju. Ako se primeti siva voda, važno je zabeležiti i druge znakove (miris, pena, mrtve životinje).
        </p>
        <h4>Crvenkasta</h4>
        <p>
          Prisustvo minerala ili specifičnih podloga. Crvenkasta voda se često javlja u područjima bogatim gvožđem - prirodna pojava, ali može izgledati dramatično. Ako se pojavi iznenada ili uz neprijatan miris, može ukazivati na zagađenje.
        </p>
        <h4>Plava</h4>
        <p>
          Vrlo čista, duboka voda. Plava boja se javlja kada je voda toliko bistra da apsorbuje crveni deo spektra svetlosti - znak izuzetno dobrog kvaliteta.
        </p>
        <h4>Žuta</h4>
        <p>
          Prisustvo organskih materija. Mogući uzroci: opalo lišće, tresetišta, huminske kiseline. U šumskim potocima žućkasta voda je česta i prirodna. Ali ako je miris neprijatan - može biti znak biološkog zagađenja.
        </p>
        <h4>Druga (neuobičajena boja)</h4>
        <p>
          Sve što odstupa od prirodnih nijansi. Primeri: narandžasta, ljubičasta, fluorescentno zelena, mlečno bela. Ovakve boje često ukazuju na hemijsko zagađenje i važno ih je odmah zabeležiti.
        </p>
        <p><strong>Zašto je važno da građani beleže boju vode?</strong></p>
        <ul>
          <li>Boja se može promeniti u roku od nekoliko minuta - stručnjaci to ne mogu uvek da isprate.</li>
          <li>Veliki broj prijava pomaže da se otkriju obrasci i ponavljajuće pojave.</li>
          <li>Boja vode je često prvi znak zagađenja ili poremećaja u ekosistemu.</li>
          <li>Građanska nauka omogućava da se promene prate dugoročno, što je ključno za zaštitu vlažnih staništa.</li>
          <li>Podaci o boji vode pomažu u otkrivanju problema pre nego što postanu ozbiljni (npr. masovna uginuća riba).</li>
        </ul>

        {/* 3.4 */}
        <h3>3.4. Vidljivo dno - zašto je važno</h3>
        <p>
          Vidljivost dna je jednostavan, ali izuzetno koristan pokazatelj stanja vodenog ekosistema. Ona govori o tome koliko je voda opterećena česticama, sedimentom ili zagađenjem. Čak i kratko vizuelno opažanje može pomoći da se otkriju problemi koji bi inače ostali neprimećeni.
        </p>
        <h4>Da - dno je jasno vidljivo</h4>
        <p>
          Voda je čista, bez većih čestica i zamućenja. Ekosistem je stabilan, nema prekomerne erozije, biljni i životinjski svet imaju dobre uslove. U vodama gde se vidi dno često žive vrste koje su osetljive na zagađenje što je dobar znak.
        </p>
        <h4>Jedva - dno se vidi samo na maloj dubini</h4>
        <p>
          Voda je blago zamućena, ali nije potpuno mutna. Mogući uzroci: nedavna kiša, blago uzburkana voda, prisustvo planktona, prirodno mešanje sedimenta. Ako se ovo stanje ponavlja, može ukazivati na početak erozije ili povećan unos čestica u vodu.
        </p>
        <h4>Ne - dno se uopšte ne vidi</h4>
        <p>
          Voda je jako mutna i neprozirna. Mogući razlozi: erozija zemljišta, radovi uz vodotok, ispuštanje otpadnih voda, poplave, intenzivna poljoprivreda. Mutna voda smanjuje količinu svetlosti, što utiče na biljke, ribe i vodozemce. Ovo može biti prvi znak ozbiljnog problema u ekosistemu.
        </p>
        <p><strong>Zašto je važno da građani beleže vidljivost dna?</strong></p>
        <ul>
          <li>Vidljivost dna se menja brzo - stručnjaci ne mogu uvek da budu na terenu.</li>
          <li>Veliki broj prijava pomaže da se otkriju obrasci (npr. gde se voda najčešće muti).</li>
          <li>Ovo je jedan od najranijih pokazatelja zagađenja ili erozije.</li>
          <li>Dugoročno praćenje pomaže u planiranju zaštite vlažnih staništa.</li>
        </ul>

        {/* 3.5 */}
        <h3>3.5. Alge na površini - zašto je važno</h3>
        <p>
          Prisustvo algi na površini vode može biti potpuno prirodno, ali može biti i znak da se u vodi dešavaju ozbiljne promene. Zato je važno da građani zabeleže koliko algi vide, čak i jednostavna procena može pomoći stručnjacima da prate stanje ekosistema.
        </p>
        <h4>Ne - nema algi</h4>
        <p>
          Površina vode je čista. Voda je stabilna, nema prekomernog unosa hranljivih materija, ekosistem funkcioniše normalno.
        </p>
        <h4>Da malo - prisutne su male količine algi</h4>
        <p>
          Tanke zelene površine, male mrlje ili rasute alge. Ovo je često potpuno prirodno, naročito u toplim mesecima. Ako se „malo" pretvori u „mnogo" u kratkom roku - to može biti znak da se nešto menja.
        </p>
        <h4>Da mnogo - velika količina algi</h4>
        <p>
          Guste zelene površine, „tepih" algi, cvetanje vode. Ovo može ukazivati na eutrofikaciju (previše hranljivih materija u vodi), smanjuje kiseonik u vodi, može dovesti do uginuća riba, često je povezano sa poljoprivrednim oticajem ili kanalizacijom. Neke vrste algi mogu da proizvedu toksine opasne za ljude i životinje, zato je važno prijaviti ovakvo stanje.
        </p>
        <p><strong>Zašto je važno da građani beleže prisustvo algi?</strong></p>
        <ul>
          <li>Alge su jedan od najbržih pokazatelja promene kvaliteta vode.</li>
          <li>Cvetanje algi može da se desi u roku od 24 sata - građani su često prvi koji to primete.</li>
          <li>Veliki broj prijava pomaže da se otkrije gde se najčešće javlja eutrofikacija.</li>
          <li>Podaci o algama pomažu u sprečavanju uginuća riba i drugih organizama.</li>
          <li>Ovo je ključni indikator za dugoročno praćenje zdravlja vlažnih staništa.</li>
        </ul>

        {/* 3.6 */}
        <h3>3.6. Vodene biljke - zašto je važno</h3>
        <p>
          Vodene biljke su jedan od najvažnijih pokazatelja zdravlja vodenog ekosistema. One nisu samo „ukras" - one čiste vodu, proizvode kiseonik, pružaju zaklon životinjama i stabilizuju obale. Zato je važno da građani zabeleže da li su vodene biljke prisutne na lokaciji.
        </p>
        <h4>Da - vodene biljke su prisutne</h4>
        <p>
          To znači da u vodi postoje biljke poput trske, rogoza, lokvanja, šaša ili podvodnih biljaka. Biljke proizvode kiseonik i poboljšavaju kvalitet vode, pružaju sklonište ribama, punoglavcima i insektima, sprečavaju eroziju obala, smanjuju mutnoću vode tako što zadržavaju sediment. Lokvanj može da stvori čitave „plutajuće vrtove" koji su dom mnogim vrstama.
        </p>
        <h4>Ne - nema vodenih biljaka</h4>
        <p>
          Ovo ne mora da bude loše, ali može ukazivati na određene probleme. Mogući razlozi: voda je previše duboka, dno je nestabilno ili previše muljevito, prekomerna senka (npr. gusta šuma), zagađenje ili nedostatak svetlosti, nedavno čišćenje ili intervencije. Ako se na mestima gde su ranije postojale vodene biljke sada ne vidi ništa, to može biti znak da se ekosistem menja.
        </p>
        <p><strong>Zašto je važno da građani beleže prisustvo vodenih biljaka?</strong></p>
        <ul>
          <li>Vodene biljke su „prirodni filteri" - njihovo prisustvo govori o kvalitetu vode.</li>
          <li>Njihov nestanak može biti prvi znak zagađenja ili promene u nivou vode.</li>
          <li>Veliki broj prijava pomaže da se otkrije gde se biljke povlače, a gde se šire.</li>
          <li>Podaci su dragoceni za planiranje obnove staništa.</li>
        </ul>

        {/* 3.7 */}
        <h3>3.7. Okolno bilje - zašto je važno</h3>
        <p>
          Biljke oko vode su jednako važne kao i one u vodi. One štite obale, sprečavaju eroziju, filtriraju zagađivače i stvaraju hlad koji je ključan za mnoge vrste. Zato je važno zabeležiti da li oko vode postoji vegetacija.
        </p>
        <h4>Da - postoji okolno bilje</h4>
        <p>
          To znači da oko vode raste trava, žbunje, drveće. Korenje biljaka učvršćuje obalu i sprečava urušavanje, vegetacija filtrira zagađivače pre nego što stignu do vode, pruža zaklon pticama, insektima i malim sisarima, stvara hlad koji sprečava pregrevanje vode. Obale sa prirodnom vegetacijom imaju i do 10 puta više vrsta nego obale bez bilja.
        </p>
        <h4>Ne - nema okolnog bilja</h4>
        <p>
          Ovo može biti znak da je obala degradirana ili da je stanište pod pritiskom. Mogući razlozi: košenje i čišćenje obala, izgradnja, betoniranje, nasipi, intenzivna poljoprivreda, erozija, nedostatak prostora za prirodnu vegetaciju. Obale bez bilja su mnogo podložnije eroziji i zagađenju, a životinjama nedostaje zaklon.
        </p>
        <p><strong>Zašto je važno da građani beleže okolno bilje?</strong></p>
        <ul>
          <li>Vegetacija oko vode je ključna za stabilnost obala.</li>
          <li>Njeno odsustvo može ukazivati na degradaciju staništa.</li>
          <li>Podaci pomažu da se identifikuju lokacije koje zahtevaju obnovu.</li>
          <li>Građani često prvi primete kada se obala „ogoli" ili kada se vegetacija ukloni.</li>
        </ul>

        {/* 3.8 */}
        <h3>3.8. Životinje u ili na vodi - zašto je važno</h3>
        <p>
          Prisustvo životinja jedan je od najvažnijih pokazatelja zdravlja vlažnog staništa. Ako se u vodi ili oko nje vide ribe, ptice, žabe, insekti ili druge vrste, to znači da ekosistem funkcioniše i da pruža dovoljno hrane, kiseonika i skloništa. Zato je važno da građani zabeleže da li su uopšte primetili životinje tokom posmatranja.
        </p>
        <h4>Da - životinje su prisutne</h4>
        <p>
          Ovo je odličan znak. Životinje su često prvi pokazatelji da je voda dovoljno čista i da stanište ima stabilne uslove. Pokazuje da ekosistem podržava život, ukazuje na dobar kvalitet vode, pomaže u praćenju sezonskih promena (npr. migracije ptica, mrest riba), omogućava stručnjacima da prate populacije osetljivih vrsta. Ako vidite viline konjice - to je gotovo siguran znak da je voda relativno čista.
        </p>
        <h4>Ne - nema vidljivih životinja</h4>
        <p>
          Ovo ne mora odmah da znači da je stanište ugroženo, ali može biti važan podatak. Mogući razlozi: vreme posmatranja (npr. podne, vrućina, hladnoća), sezona (zimi je manje aktivnosti), stanište je novo ili degradirano, voda je zagađena ili ima malo kiseonika. Ako se na lokaciji gde su ranije viđane životinje sada ne vidi ništa - to može biti znak promene u ekosistemu.
        </p>
        <p><strong>Zašto je važno da građani beleže prisustvo životinja?</strong></p>
        <ul>
          <li>Životinje su „živi indikatori" kvaliteta vode.</li>
          <li>Njihovo prisustvo ili odsustvo pomaže u otkrivanju problema.</li>
          <li>Veliki broj prijava pomaže da se prate populacije kroz vreme.</li>
          <li>Podaci su dragoceni za zaštitu ugroženih vrsta i planiranje očuvanja.</li>
        </ul>

        {/* 3.9 */}
        <h3>3.9. Koje životinje ste videli - zašto je važno</h3>
        <p>
          Kada građani zabeleže koje su vrste videli, oni pružaju izuzetno vredne informacije o biodiverzitetu i stanju staništa. Svaka grupa životinja govori nešto drugačije o kvalitetu vode i okoline.
        </p>
        <h4>Ribe</h4>
        <p>
          Prisustvo riba ili mlađi. Ribe su osetljive na zagađenje i nizak kiseonik, prisustvo mlađi znači da se ribe uspešno mreste, nagle promene u broju riba mogu ukazivati na problem. Ako vidite ribe pri površini kako „hvataju vazduh", to je znak niskog kiseonika.
        </p>
        <h4>Vodozemci</h4>
        <p>
          Žabe, punoglavci, daždevnjaci. Vodozemci su među najosetljivijim grupama na zagađenje, njihov nestanak je često prvi znak problema, prisustvo punoglavaca znači da je voda pogodna za razvoj. Žabe dišu i kroz kožu - zato su toliko osetljive na promene u vodi.
        </p>
        <h4>Ptice</h4>
        <p>
          Vodene ptice, grabljivice, selice. Ptice pokazuju koliko je stanište bogato hranom, migratorne vrste ukazuju na međunarodni značaj lokacije, grabljivice (npr. orlovi, vetruške) ukazuju na stabilan lanac ishrane. Ako vidite čaplju - to znači da u vodi gotovo sigurno ima riba ili žaba.
        </p>
        <h4>Insekti</h4>
        <p>
          Vilini konjici, komarci, tvrdokrilci, vodeni insekti. Mnogi insekti žive deo života u vodi, pa su odlični indikatori kvaliteta, vilini konjici žive samo u relativno čistoj vodi, veliki broj komaraca može ukazivati na stajaću vodu bez predatora. Vilini konjici su među najstarijim letećim insektima na planeti - postoje preko 300 miliona godina.
        </p>
        <h4>Gmizavci</h4>
        <p>
          Zmije, barske kornjače. Gmizavci su često znak stabilnog staništa, kornjače ukazuju na mirne, stabilne vodene površine, a većina zmija u Srbiji je potpuno bezopasna i važna za ekosistem. Belouška je odličan plivač i često se može videti kako lovi ribu.
        </p>
        <h4>Drugo</h4>
        <p>
          Bilo koja druga viđena vrsta - korisnik može upisati ime, a takođe može upisati da je razvojni oblik video: jaja, larve, odrasle jedinke. Može upisati preciznije koje je tačno životinje video. Na primer:
        </p>
        <ul>
          <li><strong>Ribe:</strong> šarani, pastrmke, somovi, crnke, grgeči, štuke, jesetrovke (razvojni oblik - mlađ/ikra)</li>
          <li><strong>Vodozemci:</strong> žabe, mrmoljci, daždevnjaci (razvojni oblik - jaja, punoglavci)</li>
          <li><strong>Gmizavci:</strong> barske kornjače, kopnene kornjače, zmije, gušteri, gekoni (razvojni oblik - jaja)</li>
          <li><strong>Ptice:</strong> ptice vodarice, grabljivice, pevačice (razvojni oblik - jaja)</li>
          <li><strong>Sisari:</strong> sitne zveri, krupne zveri, glodari, slepi miševi</li>
          <li><strong>Mekušci:</strong> puževi, školjke</li>
          <li><strong>Prstenasti crvi:</strong> pijavice</li>
          <li><strong>Insekti:</strong> vilini konjici, tvrdokrilci, opnokrilci, mrežokrilci, pravokrilci</li>
        </ul>
        <p>
          Ovo pomaže u otkrivanju retkih vrsta, omogućava stručnjacima da prate neočekivane pojave, doprinosi boljem razumevanju lokalnog biodiverziteta.
        </p>
        <p><strong>Zašto je važno da građani beleže koje su vrste videli?</strong></p>
        <ul>
          <li>Svaka vrsta je „podatak" o zdravlju ekosistema.</li>
          <li>Veliki broj prijava pomaže da se prate populacije kroz vreme.</li>
          <li>Podaci mogu otkriti pojavu invazivnih vrsta.</li>
          <li>Građani često prvi primete promene koje stručnjaci ne bi mogli da uoče na vreme.</li>
          <li>Ove informacije su ključne za planiranje zaštite i obnove vlažnih staništa.</li>
        </ul>

        {/* 4. UOČENE OPASNOSTI */}
        <h2>4. Uočene opasnosti</h2>
        <p>
          Uočene opasnosti su možda najvažniji aspekt u kome građani mogu da aktivno učestvuju i zaista pomognu očuvanju staništa. One pomažu da se na vreme otkriju problemi koji mogu ozbiljno da ugroze vlažna staništa, životinje, pa čak i zdravlje ljudi. Građani su često prvi koji primete promene na terenu - zato su njihove prijave dragocene. Svaka od navedenih opasnosti može biti znak da se u ekosistemu dešava nešto što zahteva pažnju stručnjaka.
        </p>

        {/* 4.1 */}
        <h3>4.1. Hemijsko zagađenje</h3>
        <p>
          Masni sjaj, jak hemijski miris, neobična boja, veštačka pena. Hemijsko zagađenje je jedna od najopasnijih pojava u vodenim ekosistemima. Može poticati iz industrije, poljoprivrede, kanalizacije ili nelegalnih ispuštanja. Može izazvati masovno uginuće riba i drugih životinja, utiče na kvalitet vode i zdravlje ljudi, često se brzo širi nizvodno. Ako vidite masni film na vodi ili jak hemijski miris — to je znak za hitnu prijavu.
        </p>

        {/* 4.2 */}
        <h3>4.2. Biološko zagađenje</h3>
        <p>
          Mrtve ribe, truo miris, tamna mutna voda, organski otpad. Biološko zagađenje nastaje kada se u vodu unese velika količina organske materije — npr. otpad iz farmi, kanalizacija ili trule biljke. Smanjuje kiseonik u vodi, može dovesti do pomora riba, utiče na zdravlje ljudi i životinja. Znakovi: truo miris, tamna voda, pena, mrtve životinje.
        </p>

        {/* 4.3 */}
        <h3>4.3. Industrijski otpad</h3>
        <p>
          Metal, šut, šljaka, veštački materijali, obojeni talozi. Industrijski otpad može biti veoma opasan jer sadrži teške metale, hemikalije i materijale koji se ne razgrađuju. Dugoročno zagađuje tlo i vodu, može biti toksičan za životinje i ljude, često ukazuje na nelegalno odlaganje otpada.
        </p>

        {/* 4.4 */}
        <h3>4.4. Komunalni otpad</h3>
        <p>
          Plastika, flaše, kese, limenke, ambalaža. Ovo je najčešći tip otpada koji građani primećuju. Plastika se raspada na mikroplastiku koja ulazi u lanac ishrane, životinje se mogu zaplesti ili progutati otpad, narušava izgled i funkciju staništa. Čak i mala količina otpada je vredno prijaviti.
        </p>

        {/* 4.5 */}
        <h3>4.5. Povećana sedimentacija</h3>
        <p>
          Braon mutna voda, mulj, slojevi nanosa. Sedimentacija se povećava kada se zemlja erodira i ulazi u vodotok. Smanjuje bistrinu vode, zatrpava staništa riba i vodozemaca, može biti znak radova, seče šuma ili erozije.
        </p>

        {/* 4.6 */}
        <h3>4.6. Brana / barijera</h3>
        <p>
          Zaustavljena voda, veštački nasipi, smanjen protok nizvodno. Brane i barijere menjaju prirodni tok vode. Sprečavaju migraciju riba, menjaju nivo vode, mogu izazvati poplave uzvodno i sušu nizvodno.
        </p>

        {/* 4.7 */}
        <h3>4.7. Preusmerenje vodotoka</h3>
        <p>
          Suvi delovi korita, voda u kanalu/cevi, novi iskop. Preusmeravanje vode često se radi zbog navodnjavanja, gradnje ili industrije. Može potpuno uništiti prirodno stanište, utiče na sve vrste koje zavise od vode, može ostaviti čitave delove rečnog korita suvim.
        </p>

        {/* 4.8 */}
        <h3>4.8. Prekomerna upotreba vode</h3>
        <p>
          Nizak nivo vode, suve zone, pumpe i cevi. Kada se previše vode crpi iz izvora, reka ili jezera, ekosistem pati. Smanjuje se količina kiseonika, ugrožava ribe i vodozemce, može dovesti do potpunog presušivanja.
        </p>

        {/* 4.9 */}
        <h3>4.9. Nizak kiseonik</h3>
        <p>
          Ribe pri površini „hvataju vazduh", uginuća, ustajao miris, puno algi, mehurići. Nizak kiseonik je čest uzrok pomora riba. Ukazuje na ozbiljan poremećaj u vodi, često je posledica cvetanja algi ili zagađenja, može se brzo pogoršati. Ako ribe plutaju ili se skupljaju pri površini — to je jasan znak da nešto nije u redu.
        </p>

        {/* 4.10 */}
        <h3>4.10. Invazivne vrste</h3>
        <p>
          Neuobičajene vrste prisutne. Invazivne vrste brzo se šire i potiskuju domaće. Menjaju ekosistem, smanjuju broj domaćih vrsta, teško ih je ukloniti kada se jednom prošire. Upisati u polje koja vrsta je u pitanju ako je prepoznata.
        </p>

        {/* 4.11 */}
        <h3>4.11. Suša</h3>
        <p>
          Ispucalo tlo, uvele biljke. Suša utiče na sve vrste koje zavise od vode. Smanjuje dostupnost vode, povećava temperaturu vode, ugrožava vodozemce i ribe.
        </p>

        {/* 4.12 */}
        <h3>4.12. Poplava</h3>
        <p>
          Voda preliva obalu, razbacano granje/blato, brzi tok. Poplave mogu biti prirodne, ali i posledica ljudskih intervencija. Menjaju strukturu staništa, mogu doneti zagađenje i otpad, utiču na životinje i biljke.
        </p>

        {/* 4.13 */}
        <h3>4.13. Erozija</h3>
        <p>
          Urušene obale, izloženi koreni, mutna voda posle kiše. Erozija je znak da je obala nestabilna. Povećava sedimentaciju, uništava staništa, može biti posledica seče šuma ili radova.
        </p>

        {/* 4.14 */}
        <h3>4.14. Prekomerni ribolov</h3>
        <p>
          Nedozvoljene mreže, oprema ostavljena na obali. Nelegalni ribolov ozbiljno ugrožava populacije riba. Smanjuje broj riba, narušava lanac ishrane, oprema može povrediti životinje.
        </p>

        {/* 4.15 */}
        <h3>4.15. Olovna sačma</h3>
        <p>
          Sitne metalne kuglice, lovna područja. Olovna sačma je opasna za ptice i druge životinje. Ptice je često progutaju misleći da je hrana, olovo je toksično i akumulira se u organizmima, može kontaminirati tlo i vodu.
        </p>

        {/* 4.16 */}
        <h3>4.16. Radioaktivni materijali</h3>
        <p>
          Znak opasnosti, sumnjiva burad — ne dirati. Ovo je retko, ali izuzetno opasno. Može biti opasno po zdravlje, zahteva hitnu reakciju nadležnih, nikada ne prilaziti i ne dirati.
        </p>

        {/* 4.17 */}
        <h3>4.17. Drugo</h3>
        <p>
          Bilo šta neuobičajeno ili sumnjivo. Ovo polje je važno jer priroda je nepredvidiva — građani mogu primetiti nešto što ne spada ni u jednu kategoriju. Omogućava prijavu novih ili retkih pojava, pomaže stručnjacima da otkriju neočekivane probleme.
        </p>

        {/* 5. MIKRO-LEKCIJE */}
        <h2>5. Mikro-lekcije</h2>

        <div className="micro-lesson">
          <h3>Lekcija 1: Zašto su vlažna staništa posebna</h3>
          <p>
            Vlažna staništa deluju kao prirodni filteri. Prečišćavaju vodu, zadržavaju zagađivače i podržavaju opstanak velikog broja vrsta. Čak i male bare mogu biti izuzetno bogate životom. Vaša zapažanja pomažu naučnicima da prate promene.
          </p>
        </div>

        <div className="micro-lesson">
          <h3>Lekcija 2: Prepoznavanje invazivnih vrsta</h3>
          <p>
            Invazivne biljke poput javorolisnog jasena ili amorfe brzo se šire i potiskuju domaće vrste. Ako vidite biljku koja neprirodno dominira prostorom, fotografišite je i prijavite.
          </p>
        </div>

        <div className="micro-lesson">
          <h3>Lekcija 3: Ptice kao pokazatelji</h3>
          <p>
            Ptice brzo reaguju na promene u životnoj sredini. Nagli porast ili pad određenih vrsta može ukazivati na zagađenje, gubitak staništa ili klimatske promene. Vaša opažanja su dragocena.
          </p>
        </div>

        <div className="micro-lesson">
          <h3>Lekcija 4: Zašto su fotografije važne</h3>
          <p>
            Jedna jasna fotografija može potvrditi vrstu, dokumentovati zagađenje ili prikazati stanje staništa. Čak i ako niste sigurni šta ste fotografisali, pošaljite - stručnjaci će prepoznati.
          </p>
        </div>

      </div>
    </div>
  );
};

export default WetlandsInfo;
